module.exports = __webpack_public_path__ + "static/media/water5.434dfb27.svg";